import { RxCopy } from "react-icons/rx";
import { showToast } from "../../utils/Toast";

const CopyButton = ({ valueToCopy }) => {
    const handleCopy = () => {
      navigator.clipboard
        .writeText(valueToCopy)
        .then(() => showToast("Copied to clipboard", "success"))
        .catch(() => showToast("Failed to copy", "error"));
    };
  
    return (
      <button onClick={handleCopy} title="Copy">
        <RxCopy className="text-gray-500 hover:text-blue-500 text-[16px]" />
      </button>
    );
  };
export default CopyButton;
